import { createRef, useRef, useState, useEffect } from "react";
import { useCampaignLeadEventQuery } from "../../../Services/campign/campignList";
import { capitalizeFirstLetter } from "../../reusableComponent/CapitalLetter";
import { formatDatee } from "../../reusableComponent/DateFormat";

interface IPROPS {
  tasks: any;
  setLiftingTaskData: any;
}

const TasksTab: React.FC<IPROPS> = ({ tasks, setLiftingTaskData }) => {
  console.log(tasks, "tasksks");

  const [taskData, setTaskData] = useState([]);

  const {
    data: campaignTaskData,
    isLoading: campaignTaskLoading,
    status: campaignStatus,
    refetch: campaignTaskRefetch,
  } = useCampaignLeadEventQuery(tasks?.id);

  const convertToIST = (utcDateString: string) => {
    if (!utcDateString) return "";
    const date = new Date(utcDateString);
    let timeStr = date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "Asia/Kolkata",
    });

    // Convert am/pm to AM/PM
    return timeStr.replace(/am|pm/, (match) => match.toUpperCase());
  };

  console.log(campaignTaskData, "campaiiidi");

  useEffect(() => {
    if (campaignTaskData) {
      setTaskData(campaignTaskData);
    }
  }, [campaignTaskData]);

  useEffect(() => {
    setLiftingTaskData(() => campaignTaskRefetch);
  }, [campaignTaskRefetch, setLiftingTaskData]);
  

  return (
    <>
      <div className="table-responsive">
        <table className="table table-row-bordered table-row-gray-300 text-muted align-middle gs-10">
          <thead className="table-light fw-bolder">
            <tr className="bg-primary">
              <th scope="col">Title</th>
              <th scope="col">Created on</th>
              <th scope="col">Due date</th>
              <th scope="col">Time due</th>
              <th scope="col">Task description</th>
              <th scope="col">Attachment</th>
              <th scope="col">Status</th>
              {/* <th scope="col">Download</th> */}
            </tr>
          </thead>
          <tbody className="table-group-divider">
            {taskData?.map((tasks, index) => (
              <tr key={index}>
                <th scope="row">{tasks?.title}</th>
                <td>{formatDatee(tasks?.created)}</td>
                <td>{formatDatee(tasks?.event_date)}</td>
                <td>{convertToIST(tasks?.start_time)}</td>
                <td
                  data-toggle="tooltip"
                  data-placement="top"
                  title={tasks.event_description?.replace(
                    /<\/?[^>]+(>|$)/g,
                    ""
                  )}
                  style={{
                    maxWidth: "100px",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                  }}
                >
                  {tasks.event_description?.replace(/<\/?[^>]+(>|$)/g, "")}
                </td>

                {/* Attachment Names */}
                <td>
                  {tasks.attachments && tasks.attachments.length > 0 ? (
                    tasks.attachments.map((attachment, attIndex) => (
                      <div key={attIndex}>
                        <a
                          href={attachment?.file}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary text-decoration-none"
                        >
                          {attachment.file_name}
                        </a>
                      </div>
                    ))
                  ) : (
                    <span>No attachments</span>
                  )}
                </td>

                <td>{capitalizeFirstLetter(tasks?.status)}</td>
                {/* Download Icons */}
                {/* <td>
                  {tasks.attachments && tasks.attachments.length > 0 ? (
                    tasks.attachments.map((attachment, attIndex) => (
                      <div key={attIndex}>
                        <a
                          href={attachment?.file}
                          download={attachment?.file_name}
                        >
                          <i className="bi bi-download fs-5 text-dark cursor-pointer"></i>
                        </a>
                      </div>
                    ))
                  ) : (
                    <span>-</span>
                  )}
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default TasksTab;